import React from "react";
import { Flame } from "lucide-react";

export function HeatBadge(props) {
  const { change, playerType, cutoff = 0.100 } = props;
  const isHot = playerType === "pitcher" ? Number(change) < 0 : Number(change) > 0;
  const delta = Math.abs(Number(change));
  if (delta < cutoff) return null;
  return (
    <span
      className={`inline-flex items-center gap-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
        isHot ? "bg-orange-100 text-orange-600" : "bg-slate-100 text-slate-500"
      }`}
    >
      <Flame size={9} />
      {isHot ? "HOT" : "COLD"}
    </span>
  );
}
